module.exports = __webpack_public_path__ + "img/aquila-favonia.fdb79b42.webp";